import dashboardHandler from 'pages/dashboards'
import mainPage from 'pages/main'
import demandChannel from 'pages/demandChannel'
import affiliateWidget from 'pages/affiliateWidget'
import propertyManager from 'pages/propertyManager'
import PageNotFound from 'pages/notfound'
import Login from 'pages/login'
import contactUsForm from 'pages/contactUsForm'
import resetPassword from 'pages/resetPassword'
import setPassword from 'pages/setPassword'
import Profile from 'pages/profile'
import ProfilePersonalInfo from 'pages/profile/personalInfo'
import ProfileSecurity from 'pages/profile/security'
import carTypesIframe from 'pages/carTypesIframe'
import { Trans } from 'services'

let tempRoutes = [];
tempRoutes = [].concat(
  require('./locations').default,
  require('./airports').default,
  require('./appLogs').default,
  require('./adminApiRequests').default,
  require('./rateManagement').default,
  require('./guestManagement').default,
  require('./bookingConditions').default,
  require('./locationInformation').default,
  require('./locationAdministration').default,
  require('./analytics').default,
  require('./locationProfile').default,
  require('./channels').default,
  require('./serverHealth').default,
  require('./roles').default,
  require('./reservations').default,
  require('./users').default,
  require('./vendors').default,
  require('./generalSettings').default,
  require('./externalEmails').default,
  require('./integrationSystems').default,
  require('./reservationActions').default,
  require('./reports').default,
  require('./audits').default,
  require('./guaranteeCard').default,
  require('./refundRequests').default,
  require('./parkingOta').default,
  require('./pointOfInterest').default,
  [
    // User profile
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      redirect: { name: 'profile.personalInfo' },
      children: [
        { path: 'personal-info', name: 'profile.personalInfo', component: ProfilePersonalInfo },
        { path: 'security', name: 'profile.security', component: ProfileSecurity },
      ]
    },
    { path: '/settings', redirect: { name: 'profile.personalInfo' } },
    { path: 'car-types-iframe', name: 'carTypesIframe', component: carTypesIframe, meta: {public: true}},
    //Main and login
    { path: 'login', name: 'login', component: Login, meta: {public: true}},
    { path: '/reset-password', name: 'resetPassword', component: resetPassword
      , meta: {public: true}},
    { path: '/set-password', name: 'setPassword', component: setPassword
      , meta: {public: true}},
    { path: '/home', name: 'home', component: dashboardHandler },
    { path: '/demand-channel', name: 'demandChannel', component: demandChannel, meta: {public: true}},
    { path: '/property-manager', name: 'propertyManager', component: propertyManager, meta: {public: true}},
    { path: '/affiliate-widget', name: 'affiliateWidget', component: affiliateWidget, meta: {public: true}},
    { path: '/contact-us', name: 'contact-us', component: contactUsForm, meta: {public: true}},
    { path: '/', name: 'property-manager', component: propertyManager, meta: {public: true} },
    { path: '*', name: 'notfound', component: PageNotFound
      , meta: {public: true}},
    ]
);

const regexp = Trans.supportedLanguages.join('|')

const routes = [
  {
    path: `/:lang(${regexp})?`,
    component: {
      template: '<router-view></router-view>'
    },
    props: (route) => ({ id: route.params.lang && Trans.isLangSupported(route.params.lang) ? route.params.lang : 'en' }),
    children: tempRoutes,
  }
]
export default routes
